import { createTheme } from '@mui/material/styles';

export const appTheme = createTheme({
  palette: {
    primary: {
      main: '#BDA273',
    },
    secondary: {
      main: '#edf2ff',
    },
  },
});
